import {ApiRequest, RequestMethod} from "../../../request";

export async function deleteWeapon(id: string): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.DELETE);
    apiRequest.setUrl(`/api/weapon/${id}`);
    const response: any = await apiRequest.send();
    return response.status === 200;
}